import React, { Component } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import { Redirect, Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { LookupMaterias } from '../MateriaCarrera/LookupMaterias';
import { LookupPeriodoExamen } from '../PeriodoExamen/LookupPeriodoExamen';

registerLocale('es', es);

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class UpdateMesaExamen extends Component {
  static displayName = UpdateMesaExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loadingInitial: true,
      loading: false,
      loadError: '',
      errorMessage: '',
      redirect: false,
      id: this.props.match.params.id,
      details: this.props.match.params.details,
      periodo: { codigo: 0, descripcion: '', fechaInicioPeriodo: new Date(), fechafinPeriodo: new Date() },
      materia: { materiaCarreraCod: '', materiaCarreraCodigo: '', materiaNombre: '', carrera: '' },
      mesaExamen: { fechaExamen: new Date(), fechaInicioInscripcion: new Date(), fechaFinInscripcion: new Date() },
      showLookupPeriodoCursada: false,
      showLookupMaterias: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get isReadOnly() {
    return this.state.details === '1';
  }

  componentDidMount() {
    const canAccess = constantClass.canAccess('WWMesaExamen');
    if (canAccess) {
      this.populateData();
    } else {
      this.setState({ loadingInitial: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleHideLookup = () => {
    this.setState({ showLookupMaterias: false });
  };

  handleStudentHideLookup = () => {
    this.setState({ showLookupPeriodoCursada: false });
  };

  handleShowStudentLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupPeriodoCursada: true });
    }
  };

  handleShowCarreraLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupMaterias: true });
    }
  };

  handleFechaExamen = (date) => {
    this.clearFeedback();
    this.setState({ mesaExamen: { ...this.state.mesaExamen, fechaExamen: date } });
  };

  handleFechaInicioInscripcion = (date) => {
    this.clearFeedback();
    this.setState({ mesaExamen: { ...this.state.mesaExamen, fechaInicioInscripcion: date } });
  };

  handleFechaFinInscripcion = (date) => {
    this.clearFeedback();
    this.setState({ mesaExamen: { ...this.state.mesaExamen, fechaFinInscripcion: date } });
  };

  handleSelectStudentItem = (e) => {
    const carreraProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupPeriodoCursada: false,
      periodo: {
        codigo: carreraProperties[0],
        descripcion: carreraProperties[1].trim() + ' - ' + carreraProperties[2].trim() + ' - ' + carreraProperties[3].trim(),
        fechaInicioPeriodo: carreraProperties[4],
        fechaFinPeriodo: carreraProperties[5],
      },
    });
  };

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupMaterias: false,
      materia: {
        materiaCarreraCod: carreraProperties[0].trim(),
        materiaCarreraCodigo: carreraProperties[1].trim(),
        materiaNombre: carreraProperties[2].trim(),
        carrera: carreraProperties[3].trim(),
      },
    });
  };

  isOkToSave() {
    return this.state.materia.materiaCarreraCod.length > 0 && this.state.periodo.descripcion.length > 0;
  }

  datesInPeriodo() {
    return (
      (new Date(this.state.periodo.fechaInicioPeriodo) <= this.state.mesaExamen.fechaExamen && new Date(this.state.periodo.fechafinPeriodo) >= this.state.mesaExamen.fechaExamen)
      && (new Date(this.state.periodo.fechaInicioPeriodo) <= this.state.mesaExamen.fechaInicioInscripcion && new Date(this.state.periodo.fechafinPeriodo) >= this.state.mesaExamen.fechaInicioInscripcion)
      && (new Date(this.state.periodo.fechaInicioPeriodo) <= this.state.mesaExamen.fechaFinInscripcion && new Date(this.state.periodo.fechafinPeriodo) >= this.state.mesaExamen.fechaFinInscripcion)
    );
  }

  datesOK() {
    return (
      this.state.mesaExamen.fechaInicioInscripcion <= this.state.mesaExamen.fechaFinInscripcion
      && this.state.mesaExamen.fechaFinInscripcion < this.state.mesaExamen.fechaExamen
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.isReadOnly) {
      return;
    }
    if (isSubmitInProgress(this.state.loading)) return;

    let okToSave = this.isOkToSave();
    let fechasOk = this.datesOK();
    let fechasEnPeriodo = true;

    if (this.state.details == 1) {
      okToSave = true;
      fechasOk = true;
      fechasEnPeriodo = true;
    }

    if (okToSave && fechasOk && fechasEnPeriodo) {
      this.saveStudent();
      return;
    }

    let errorMessage = '';
    if (!okToSave) {
      errorMessage = 'Todos los campos son obligatorios';
    } else if (!fechasOk) {
      errorMessage = 'Compruebe las fechas ingresadas, las fechas de inscripción deben ser menor a la fecha del examen';
    } else if (!fechasEnPeriodo) {
      errorMessage = 'Compruebe que las fechas se encuentren dentro del período de examen seleccionado';
    }
    this.setState({ errorMessage });
  }

  async populateData() {
    this.setState({ loadingInitial: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/mex/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loadingInitial: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudieron cargar los datos de la mesa de examen.'
        ),
      });
      return;
    }

    this.setState({
      loadingInitial: false,
      periodo: {
        codigo: data.returnModel.peridoExamenCod,
        descripcion: data.returnModel.periodoExamenDescripcion.trim() + ' - '
          + data.returnModel.periodoExamenLlamado.trim() + ' - '
          + data.returnModel.anioAcademicoDescripcion,
        fechaInicioPeriodo: constantClass.parseApiDate(data.returnModel.periodoExamenFechaInicio),
        fechafinPeriodo: constantClass.parseApiDate(data.returnModel.periodoExamenFechaFin),
      },
      materia: {
        materiaCarreraCod: data.returnModel.materiaCarreraCod.trim(),
        materiaCarreraCodigo: (data.returnModel.materiaCarreraCodigo || '').trim(),
        materiaNombre: data.returnModel.materiaCarreraNombre.trim(),
        carrera: data.returnModel.carreraNombre.trim(),
      },
      mesaExamen: {
        fechaExamen: constantClass.parseApiDate(data.returnModel.mesaExamenFechaExamen),
        fechaInicioInscripcion: constantClass.parseApiDate(data.returnModel.mesaExamenFechaInicioInscripci),
        fechaFinInscripcion: constantClass.parseApiDate(data.returnModel.mesaExamenFechaFinInscripcion),
      },
    });
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/mex', {
      method: 'POST',
      body: JSON.stringify({
        MesaExamenCod: parseInt(this.state.id, 10),
        PeridoExamenCod: this.state.periodo.codigo,
        MateriaCarreraCod: this.state.materia.materiaCarreraCod.trim(),
        InicioFechaInscripcion: constantClass.serializeDateForApi(this.state.mesaExamen.fechaInicioInscripcion),
        FinFechaInscripcion: constantClass.serializeDateForApi(this.state.mesaExamen.fechaFinInscripcion),
        FechaExamenInscripcion: constantClass.serializeDateForApi(this.state.mesaExamen.fechaExamen),
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo actualizar la mesa de examen. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-mex" />;
    }

    const {
      loadingInitial,
      loading,
      loadError,
      errorMessage,
      materia,
      periodo,
      mesaExamen,
      showLookupMaterias,
      showLookupPeriodoCursada,
    } = this.state;

    const isBusy = loading;
    const title = this.isReadOnly
      ? 'Ver datos de Mesa de Examen'
      : 'Modificar Mesa de Examen';
    const materiaDisplay = materia.materiaCarreraCodigo + ' - ' + materia.materiaNombre + ' - ' + materia.carrera;

    if (loadingInitial) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-mex">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <p className="md-form-page__skeleton"><em>Cargando datos...</em></p>
        </div>
      );
    }

    if (loadError) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-mex">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <div className="md-form-page__error" role="alert">{loadError}</div>
        </div>
      );
    }

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-mex">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">{title}</h1>
        <p className="md-form-page__subtitle">
          {this.isReadOnly
            ? 'Consulta los datos registrados de la mesa de examen.'
            : 'Actualice la materia, el período o las fechas y guarde los cambios.'}
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Actualizando mesa de examen, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Materia</span>
              {!this.isReadOnly ? (
                <button
                  type="button"
                  className="md-form-page__pick-btn"
                  onClick={this.handleShowCarreraLookup}
                  disabled={isBusy}
                >
                  Seleccione la Materia
                </button>
              ) : null}
              {showLookupMaterias ? (
                <LookupMaterias selectItem={this.handleSelectCarreraItem} hideLookup={this.handleHideLookup} />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={materiaDisplay}
                readOnly
                disabled
                aria-label="Materia"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Período de Examen</span>
              {!this.isReadOnly ? (
                <button
                  type="button"
                  className="md-form-page__pick-btn"
                  onClick={this.handleShowStudentLookup}
                  disabled={isBusy}
                >
                  Seleccione el Período de Examen
                </button>
              ) : null}
              {showLookupPeriodoCursada ? (
                <LookupPeriodoExamen
                  selectItem={this.handleSelectStudentItem}
                  hideLookup={this.handleStudentHideLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={periodo.descripcion}
                readOnly
                disabled
                aria-label="Período de examen"
              />
            </div>

            <div className="md-form-page__field">
              {this.isReadOnly ? (
                <>
                  <span className="md-form-page__label">Fecha de Examen</span>
                  <input
                    className="md-form-page__input"
                    type="text"
                    value={constantClass.formatDisplayDate(mesaExamen.fechaExamen)}
                    disabled
                    readOnly
                    aria-label="Fecha de examen"
                  />
                </>
              ) : (
                <>
                  <label className="md-form-page__label" htmlFor="mex-upd-fecha-examen">
                    Fecha de Examen
                  </label>
                  <DatePicker
                    id="mex-upd-fecha-examen"
                    className="md-form-page__input"
                    locale="es"
                    closeOnScroll
                    selected={mesaExamen.fechaExamen}
                    onChange={this.handleFechaExamen}
                    disabled={isBusy}
                    dateFormat="dd/MM/yyyy"
                  />
                </>
              )}
            </div>

            <div className="md-form-page__field">
              {this.isReadOnly ? (
                <>
                  <span className="md-form-page__label">Fecha de Inicio de Inscripción</span>
                  <input
                    className="md-form-page__input"
                    type="text"
                    value={constantClass.formatDisplayDate(mesaExamen.fechaInicioInscripcion)}
                    disabled
                    readOnly
                    aria-label="Fecha de inicio de inscripción"
                  />
                </>
              ) : (
                <>
                  <label className="md-form-page__label" htmlFor="mex-upd-fecha-inicio-inscripcion">
                    Fecha de Inicio de Inscripción
                  </label>
                  <DatePicker
                    id="mex-upd-fecha-inicio-inscripcion"
                    className="md-form-page__input"
                    locale="es"
                    closeOnScroll
                    selected={mesaExamen.fechaInicioInscripcion}
                    onChange={this.handleFechaInicioInscripcion}
                    disabled={isBusy}
                    dateFormat="dd/MM/yyyy"
                  />
                </>
              )}
            </div>

            <div className="md-form-page__field">
              {this.isReadOnly ? (
                <>
                  <span className="md-form-page__label">Fecha de Fin de Inscripción</span>
                  <input
                    className="md-form-page__input"
                    type="text"
                    value={constantClass.formatDisplayDate(mesaExamen.fechaFinInscripcion)}
                    disabled
                    readOnly
                    aria-label="Fecha de fin de inscripción"
                  />
                </>
              ) : (
                <>
                  <label className="md-form-page__label" htmlFor="mex-upd-fecha-fin-inscripcion">
                    Fecha de Fin de Inscripción
                  </label>
                  <DatePicker
                    id="mex-upd-fecha-fin-inscripcion"
                    className="md-form-page__input"
                    locale="es"
                    closeOnScroll
                    selected={mesaExamen.fechaFinInscripcion}
                    onChange={this.handleFechaFinInscripcion}
                    disabled={isBusy}
                    dateFormat="dd/MM/yyyy"
                  />
                </>
              )}
            </div>

            {!this.isReadOnly ? (
              <div className="md-form-page__actions">
                <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                  Confirmar
                </button>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    );
  }
}
